<template>
  <div class="d-flex flex-row flex-wrap">
    <div class="cardDtl">
        <div class="thumbnail"></div>
        <h1></h1>
        <p></p>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return {
            product:{
                iconSmall: 'lorem ipsum...',
                productName: 'lorem ipsum dolor siamet',
                poin:10
            }
        }
    }
}
</script>

<style scoped src="./CardLoading.scss" lang="scss" />